var _g, _mask, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshElementFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0076A8"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 15,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5833 24.6667C31.5833 25.0167 31.35 25.25 31 25.25H28.0833C27.7333 25.25 27.5 25.0167 27.5 24.6667V21.75C27.5 21.4 27.7333 21.1667 28.0833 21.1667C28.4333 21.1667 28.6667 21.4 28.6667 21.75V23.5C29.425 22.5083 29.8333 21.2833 29.8333 20C29.8333 16.7917 27.2083 14.1667 24 14.1667C20.7917 14.1667 18.1667 16.7917 18.1667 20C18.1667 23.2083 20.7917 25.8333 24 25.8333C24.35 25.8333 24.5833 26.0667 24.5833 26.4167C24.5833 26.7667 24.35 27 24 27C20.15 27 17 23.85 17 20C17 16.15 20.15 13 24 13C27.85 13 31 16.15 31 20C31 21.4583 30.5333 22.9167 29.6583 24.0833H31C31.35 24.0833 31.5833 24.3167 31.5833 24.6667Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5833 24.6667C31.5833 25.0167 31.35 25.25 31 25.25H28.0833C27.7333 25.25 27.5 25.0167 27.5 24.6667V21.75C27.5 21.4 27.7333 21.1667 28.0833 21.1667C28.4333 21.1667 28.6667 21.4 28.6667 21.75V23.5C29.425 22.5083 29.8333 21.2833 29.8333 20C29.8333 16.7917 27.2083 14.1667 24 14.1667C20.7917 14.1667 18.1667 16.7917 18.1667 20C18.1667 23.2083 20.7917 25.8333 24 25.8333C24.35 25.8333 24.5833 26.0667 24.5833 26.4167C24.5833 26.7667 24.35 27 24 27C20.15 27 17 23.85 17 20C17 16.15 20.15 13 24 13C27.85 13 31 16.15 31 20C31 21.4583 30.5333 22.9167 29.6583 24.0833H31C31.35 24.0833 31.5833 24.3167 31.5833 24.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshElementFilter);
export default __webpack_public_path__ + "static/media/refresh-element-filter.06df1a4c4fe778a3ccf77bc0340d93cf.svg";
export { ForwardRef as ReactComponent };